import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getBlog, patchBlog } from './blogAPI';

const initialState = {
  blog: {},
  isLoading: false,
  isError: false,
  error: '',
};

export const fetchBlog = createAsyncThunk('blog/fetchBlog', async (id) => {
  const blog = await getBlog(id);

  return blog;
});

export const updateBlog = createAsyncThunk(
  'blog/updateBlog',
  async ({ id, data }) => {
    const blog = await patchBlog({ id, data });

    return blog;
  }
);

export const blogSlice = createSlice({
  name: 'blog',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlog.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchBlog.fulfilled, (state, action) => {
        state.isLoading = false;
        state.blog = action.payload;
      })
      .addCase(fetchBlog.rejected, (state, action) => {
        state.isLoading = false;
        state.blog = {};
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(updateBlog.fulfilled, (state, action) => {
        const { likes, isSaved } = action.payload;
        state.blog.likes = likes;
        state.blog.isSaved = isSaved;
      });
  },
});

export default blogSlice.reducer;
